@if (germanAMLChangesEnabled) {
    @if (graceEndedforDE && (!checkBoxValue || !showProductCheckBoxDE)) {
        <show-message [type]="messageType.ERROR">
            <p error>{{ 'PARTY.CASHIER.web.deposit.graceperiod.ended' | translate }}</p>
        </show-message>
    }
    @if (productSelectionError) {
        <show-message [type]="messageType.ERROR">
            <p error>{{ 'PARTY.CASHIER.web.deposit.choose.product.text' | translate }}</p>
        </show-message>
    }
    @if (
        isGamingLimitEnabled &&
        !isGamingLimitSet &&
        isGbgVerified &&
        (depositInfo?.productPreference === 'POKER' || depositInfo?.productPreference === 'CASINO') &&
        (isBrandSupportOnlyCasinoProduct || isBrandSupportOnlyPokerProduct || isBrandSupportBothCasinoAndPokerProduct) &&
        (!checkBoxValue || !showProductCheckBoxDE)
    ) {
        <show-message [type]="messageType.ERROR">
            <div error>
                @if (isBrandSupportBothCasinoAndPokerProduct) {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.gaminglimit.casinoandpoker.message' | translate }}
                        <a href="{{ depositLimitsUrl }}" target="_top">
                            <u>{{ 'PARTY.CASHIER.web.deposit.deposit.limits.set' | translate }}</u>
                        </a>
                    </p>
                }
                @if (!isBrandSupportBothCasinoAndPokerProduct && isBrandSupportOnlyCasinoProduct) {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.gaminglimit.casino.message' | translate }} &nbsp;<a href="{{ depositLimitsUrl }}" target="_top">
                            <u>{{ 'PARTY.CASHIER.web.deposit.deposit.limits.set' | translate }}</u>
                        </a>
                    </p>
                }
                @if (!isBrandSupportBothCasinoAndPokerProduct && isBrandSupportOnlyPokerProduct) {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.gaminglimit.poker.message' | translate }} &nbsp;<a href="{{ depositLimitsUrl }}" target="_top">
                            <u>{{ 'PARTY.CASHIER.web.deposit.deposit.limits.set' | translate }}</u>
                        </a>
                    </p>
                }
            </div>
        </show-message>
    }
    <form [formGroup]="productPreferenceFormGroup">
        @if (!hideProductRadioButtons && productList.length !== 1) {
            <div>
                <div class="d-flex pr-prf-text">
                    <span
                        ><b>{{ 'PARTY.CASHIER.web.deposit.chooseproduct.text2' | translate }} &nbsp;</b>
                        <span
                            class="theme-info-i product-info-tooltip"
                            [popper]="tooltipcontent"
                            [popperPositionFixed]="true"
                            [popperTrigger]="isMobile ? NgxPopperjsTriggers.click : NgxPopperjsTriggers.hover"
                            [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></span>
                    </span>
                    <popper-content class="tooltip-info ngxp__tooltip" id="tooltipcontent" #tooltipcontent>
                        <div class="curfew-blue">
                            <div class="message-text pt-0">
                                @if (!(visaOnlyForSports && paypalOnlyForSports)) {
                                    <span>
                                        <p
                                            class="tooltip-description"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.visa.selectproduct.info.text' | translate"></p>
                                    </span>
                                }
                                @if (visaOnlyForSports && paypalOnlyForSports) {
                                    <span>
                                        <p class="tooltip-description" [vnDynamicHtml]="'PARTY.CASHIER.web.selectproduct.info.text' | translate"></p>
                                    </span>
                                }
                                <div class="tooltip-actions">
                                    <span class="btn btn-link tooltip-cta btn-height d-inline-block" (click)="tooltipcontent.hide()">{{
                                        'PARTY.CASHIER.web.common.gotit.text' | translate
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </popper-content>
                </div>
                <div class="d-flex">
                    @for (product of productList; track product; let ndx = $index) {
                        <div class="pr-prf-option">
                            @if (product === 'SPORTSBOOK') {
                                <span>
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        id="productSPORTSBOOK"
                                        name="productPreference"
                                        (change)="updateProductPreference(product)"
                                        [value]="product"
                                        formControlName="productPreference"
                                        [disabled]="(product === 'POKER' || product === 'CASINO') && productOptionDisabled"
                                        checked />
                                    <label
                                        ><b>&nbsp;{{ 'PARTY.CASHIER.web.deposit.' + product.toLowerCase() + '.textonly' | translate }}</b></label
                                    >
                                </span>
                            }
                            @if (isBrandSupportBothCasinoAndPokerProduct && !(product === 'POKER' || product === 'SPORTSBOOK')) {
                                <span>
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        id="productslotsandpoker"
                                        name="productPreference"
                                        (change)="updateProductPreference(product)"
                                        [value]="product"
                                        formControlName="productPreference"
                                        [disabled]="(product === 'POKER' || product === 'CASINO') && productOptionDisabled" />
                                    <label
                                        ><b>&nbsp;{{ 'PARTY.CASHIER.web.deposit.slotsandpoker.text.only' | translate }}</b></label
                                    >
                                </span>
                            }
                            @if (!isBrandSupportBothCasinoAndPokerProduct && isBrandSupportOnlyCasinoProduct && product === 'CASINO') {
                                <span>
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        id="productcasino"
                                        formControlName="productPreference"
                                        [value]="product"
                                        name="productPreference"
                                        (change)="updateProductPreference(product)"
                                        [disabled]="(product === 'POKER' || product === 'CASINO') && productOptionDisabled" />
                                    <label
                                        ><b>&nbsp;{{ 'PARTY.CASHIER.web.deposit.casino.textonly' | translate }}</b></label
                                    >
                                </span>
                            }
                            @if (!isBrandSupportBothCasinoAndPokerProduct && isBrandSupportOnlyPokerProduct && product === 'POKER') {
                                <span>
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        id="productpoker"
                                        [value]="product"
                                        name="productPreference"
                                        (change)="updateProductPreference(product)"
                                        formControlName="productPreference"
                                        [disabled]="(product === 'POKER' || product === 'CASINO') && productOptionDisabled" />
                                    <label
                                        ><b>&nbsp;{{ 'PARTY.CASHIER.web.deposit.poker.textonly' | translate }}</b></label
                                    >
                                </span>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </form>
}
